module.exports = __webpack_public_path__ + "static/media/icon-coin-services-bottom.0b948cb4.png";